import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, Network, Server, Shield, Monitor, Lightbulb, Sun } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { motion } from 'framer-motion';

const iconMap = {
  Phone,
  Network,
  Server,
  Shield,
  Monitor,
  Lightbulb,
  Sun,
};

export const ServiceCard = ({ service, index = 0 }) => {
  const IconComponent = iconMap[service.icon] || Server;
  const colorClass = service.color === 'accent' ? 'accent' : 'primary';
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="h-full"
    >
      <Card className="group h-full flex flex-col hover:shadow-xl hover:border-primary/30 hover:-translate-y-1 transition-all duration-300">
        <CardContent className="flex flex-col h-full p-6">
          {/* Icon */}
          <div
            className={`w-14 h-14 rounded-xl flex items-center justify-center mb-5 transition-all duration-300 ${
              colorClass === 'accent'
                ? 'bg-accent/10 group-hover:bg-accent'
                : 'bg-primary/10 group-hover:bg-primary'
            }`}
          >
            <IconComponent
              className={`w-7 h-7 transition-colors duration-300 ${
                colorClass === 'accent'
                  ? 'text-accent group-hover:text-accent-foreground'
                  : 'text-primary group-hover:text-primary-foreground'
              }`}
            />
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-foreground mb-3 group-hover:text-primary transition-colors">
            {service.name}
          </h3>

          {/* Description */}
          <p className="text-sm text-muted-foreground mb-5 flex-grow">
            {service.shortDescription}
          </p>

          {/* Link */}
          <Link
            to={service.route || `/services#${service.id}`}
            className={`inline-flex items-center gap-2 text-sm font-medium transition-colors mt-auto ${
              colorClass === 'accent'
                ? 'text-accent hover:text-accent/80'
                : 'text-primary hover:text-primary/80'
            }`}
          >
            Learn More
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </CardContent>
      </Card>
    </motion.div>
  );
};
